import async from 'async';
import { UniversalPromiseHelper } from '@biteinc/helpers-universal';
export function asCallback(promise, callback) {
    promise.then((result) => {
        async.setImmediate(() => {
            callback(null, result);
        });
    }, (err) => {
        async.setImmediate(() => {
            callback(err);
        });
    });
}
export async function awaitPromiseAndWrapError(promise, errorWrapper) {
    try {
        const result = await promise;
        return result;
    }
    catch (err) {
        const wrappedError = errorWrapper(err);
        throw wrappedError;
    }
}
export async function throwErrorAfterAwaitingBlock(mdErr, block) {
    try {
        await block();
    }
    finally {
        throw mdErr;
    }
}
export function wrapInPromise(functionExpectingCallback) {
    return new Promise((resolve, reject) => {
        functionExpectingCallback((err, value) => {
            return err ? reject(err) : resolve(value);
        });
    });
}
export const reflect = UniversalPromiseHelper.reflect;
export async function reflectAndWrapInPromise(functionExpectingCallback) {
    return reflect(wrapInPromise(functionExpectingCallback));
}
export const sleep = UniversalPromiseHelper.sleep;
export async function withTimeout(block, timeoutHandler, milliseconds) {
    return wrapInPromise(async.timeout(block, milliseconds)).catch((error) => {
        if (error.code === 'ETIMEDOUT') {
            return timeoutHandler();
        }
        throw error;
    });
}
export async function waitUntil(checkerAsync, maxWaitTime, interval) {
    let success = false;
    let count = 0;
    await async.doUntil(async () => {
        if (await checkerAsync()) {
            success = true;
        }
        else {
            count += 1;
            await sleep(interval);
        }
    }, async () => {
        return success || count === Math.ceil(maxWaitTime / interval);
    });
    return success;
}
export async function poll(options) {
    let success = false;
    let result;
    await async.doUntil(async () => {
        result = await options.pollingFunction();
        if (options.testFunction(result)) {
            success = true;
        }
        else {
            await sleep(options.interval);
        }
    }, async () => {
        return success;
    });
    return result;
}
//# sourceMappingURL=promise_helper.js.map